var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrownAlt = function SvgCrownAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 8,
    d: "M111.895 56.057 102.83 96.09A3.685 3.685 0 0 1 99.145 99H28.54a3.685 3.685 0 0 1-3.685-2.91l-8.77-40.033a3.687 3.687 0 0 1 5.233-4.088l21.52 10.423 17.836-31.525a3.685 3.685 0 0 1 6.411 0l17.836 31.562 21.668-10.496a3.69 3.69 0 0 1 3.988.347 3.68 3.68 0 0 1 1.318 3.777Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrownAlt);
export default ForwardRef;